import {accountingService, walletService} from "@/common/api.service";
import Vue from "vue";

const initialStates = {
    switching_settings: null,
    loading: false
};


const getters = {
    switching_settings: ({ switching_settings }) => switching_settings,
    loading: ({ loading }) => loading
};

const mutations = {
    switchingSettings(state, switching_settings) {
        state.switching_settings = switching_settings;
    },
    loading(state) {
        state.loading = true;
    },
    loaded(state) {
        state.loading = false;
    },
    newSwitchingSettingForBankId(state, bank_id) {
        Vue.set(state.switching_settings, bank_id, {
            list: [],
            status: false
        });
    }
};

const actions = {
    fetchSwitchingSettings({commit}, fetch_starshop) {
        commit("loading");
        return walletService.switchingSettings().then(response => {
            commit("switchingSettings", response.data.data);
            commit("loaded");
        });
    },
    fetchStarShopSwitchingSettings({commit}) {
        commit("loading");
        return walletService.switchingStarShopSettings().then(response => {
            commit("switchingSettings", response.data.data);
            commit("loaded");
        });
    },
    addNewBankSwitchingSetting({ commit }, bank_id) {
        commit("loading");
        commit('newSwitchingSettingForBankId', bank_id);
        commit("loaded");
    }
};


export default {
    namespaced: true,
    state: initialStates,
    getters: getters,
    actions: actions,
    mutations: mutations,
};
